<script lang="ts">
  import Skeleton from "./Skeleton.svelte";
</script>

<div class="container">
  <Skeleton --skeleton-height="12px" --skeleton-width="70px" />
  <Skeleton --skeleton-height="24px" --skeleton-width="130px" />
</div>

<style>
  .container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
</style>
